import { useEffect, useState } from 'react';
import { GrPrevious, GrNext } from 'react-icons/gr';

interface Options {
    totalPages: number;
    currentPage: number;
    onPage: (p: number) => void;
}

const Pagination = ({ totalPages, currentPage, onPage }: Options) => {
    const [pageNumbers, setPageNumbers] = useState<number[]>();

    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            onPage(page);
        }
    };

    const getPageNumbers = () => {
        const maxPagesToShow = 6;
        let pages: (number | string)[] = [];

        if (totalPages <= maxPagesToShow) {
            pages = Array.from({ length: totalPages }, (_, i) => i + 1);
        } else {
            const half = Math.floor(maxPagesToShow / 2);
            let start = Math.max(1, currentPage - half);
            let end = Math.min(totalPages, currentPage + half);

            if (start === 1) {
                end = maxPagesToShow;
            } else if (end === totalPages) {
                start = totalPages - maxPagesToShow + 1;
            }

            pages = Array.from({ length: end - start + 1 }, (_, i) => start + i);

            if (start > 1) {
                pages.unshift(1, '...');
            }
            if (end < totalPages) {
                pages.push('...', totalPages);
            }
        }

        return pages;
    };

    useEffect(() => {
        let total = Array.from({ length: totalPages }, (_, i) => i + 1);
        setPageNumbers(total);
    }, [totalPages]);

    return (
        <div className="flex justify-end gap-2 mt-8">
            <button onClick={(e) => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                <GrPrevious color={currentPage === 1 ? '#D4D8DD' : '#888D95'} />
            </button>
            <div className="flex gap-2 pages">
                {getPageNumbers().map((item, index) =>
                    typeof item === 'number' ? (
                        <button
                            key={index}
                            onClick={() => handlePageChange(item)}
                            className={`w-6 px-1 py-1 text-xs font-medium text-blue-bb-1 ${item === currentPage ? 'bg-yellow-bb rounded-full' : 'bg-gray-bb-6 rounded-sm'}`}
                        >
                            {item}
                        </button>
                    ) : (
                        <span key={index} className="text-gray-500">
                            {item}
                        </span>
                    )
                )}
            </div>

            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                <GrNext color={currentPage === totalPages ? '#D4D8DD' : '#888D95'} />
            </button>
        </div>
    );
};

export default Pagination;
